import $ from "jquery"

const loadLessonFavorite = async lessonId => {
  await $.get(`/favorite_collection_memberships/load_favorite?lesson_id=${lessonId}`)
}

const getFavoriteStatus = lessonId => {
  const $favoriteComponent = $(document).find(
    `[data-favorite-lesson=${lessonId}]`
  )
  return $favoriteComponent.data("favorited")
}

const getLessonFavoriteComponents = async favoriteIds => {
  try {
    const favorites = await $.get(
      `/favorite_collection_memberships/favorited?lesson_ids=${$.makeArray(
        favoriteIds
      ).join(",")}`
    )

    if (!favorites || !Object.keys(favorites).length) {
      return []
    }

    return Object.entries(favorites).map(([key, isFavorite]) => ({
      lessonId: key,
      isFavorite,
    }))
  } catch (err) {
    console.error(err)
    return []
  }
}

const loadFavorites = async () => {
  const favoriteIds = $(document)
    .find("[data-favorite-lesson]")
    .map((_, el) => $(el).data("favorite-lesson"))
    .filter(f => f)

  if (!favoriteIds.length) {
    return
  }

  const favorites = await getLessonFavoriteComponents(favoriteIds)
  favorites.map(({ lessonId, isFavorite }) => {
    if (getFavoriteStatus(lessonId) !== isFavorite) {
      loadLessonFavorite(lessonId)
    }
  })
}

const favoriteActionComponent = {
  load: loadFavorites,
  loadLessonFavorite,
}

export default favoriteActionComponent
